import React, { useCallback } from 'react';
import { Text } from '@goodfynd/ui';
import { LoadingTruck } from '@goodfynd/ui';
import classnames from 'clsx';

import { useVendor } from '../../../context/VendorContext';

import type { DashboardPageContentProps } from './types';

import classes from './DashboardPageContent.module.css';

export default function DashboardPageContent({
  children,
  className,
  rightNode,
  title,
}: DashboardPageContentProps) {
  const { isLoading, vendor } = useVendor();

  const render = useCallback(() => {
    if (isLoading) {
      return <LoadingTruck />;
    }

    if (vendor?.id) {
      return children;
    }

    return null;
  }, [children, isLoading, vendor?.id]);

  return (
    <div className={classnames(classes.container, className)}>
      <section className={classes['header-container']}>
        {typeof title === 'string' ? (
          <Text as="heading2" tag="h1">
            {title}
          </Text>
        ) : (
          title
        )}

        {rightNode}
      </section>

      {render()}
    </div>
  );
}
